import { Link } from "react-router-dom";
import { AREAS } from "../../data";
import { Reveal } from "./Reveal";
import { MapPin, ArrowUpRight } from "lucide-react";

export const AreaSection = () => (
  <section id="area" className="relative py-24 sm:py-32 bg-[#f2ece4]">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <p className="uppercase text-xs tracking-[0.28em] text-[#8b5a2b] mb-4">
          Area Layanan
        </p>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#2c1e16] max-w-3xl leading-tight">
          Menjangkau setiap sudut Yogyakarta.
        </h2>
        <p className="mt-5 max-w-xl text-[#5c4033] leading-relaxed">
          Dari pusat kota hingga lereng Merapi — terapis kami siap datang ke
          tempat Anda.
        </p>
      </Reveal>

      <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-4">
        {AREAS.map((a, i) => (
          <Reveal key={a.slug} delay={i * 0.08}>
            <Link
              to={`/area/${a.slug}`}
              data-testid={`area-card-${a.slug}`}
              className="group block h-full overflow-hidden rounded-3xl bg-[#faf7f2] border border-[#e5d9c5] hover:shadow-[0_20px_50px_rgba(92,64,51,0.12)] transition-shadow"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={a.hero}
                  alt={`Massage panggilan area ${a.name} Jogja`}
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#2c1e16]/50 to-transparent" />
              </div>
              <div className="p-6">
                <span className="flex items-center gap-2 text-xs uppercase tracking-[0.15em] text-[#8b5a2b]">
                  <MapPin className="h-4 w-4" /> {a.short}
                </span>
                <h3 className="font-display text-3xl text-[#2c1e16] mt-2">
                  {a.name}
                </h3>
                <span className="mt-4 inline-flex items-center gap-1.5 text-sm text-[#5c4033] link-underline">
                  Lihat area {a.name}
                  <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </span>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
